import React, { useContext, useState, useEffect } from "react";
import { DashboardContext } from '../../context/DashboardContext';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, TrendlineDirective, TrendlinesDirective, Inject, Tooltip, LineSeries, ScatterSeries, SplineSeries, Trendlines, Category, Legend, Highlight } from '@syncfusion/ej2-react-charts';
import { InputLabel, MenuItem, FormControl, Select, Skeleton } from '@mui/material'
import { FaStar, FaRegStar } from "react-icons/fa";
import moment from 'moment';
import chroma from 'chroma-js';

export default function CustoXTempo({ corFavorito, cicloDemandaKey, tab }) {
    const theme = localStorage.getItem('theme') || 'light'
    const { qtdCustoXTempo, setQtdCustoXTempo, getCustoXTempo, CustoXTempo, AdicionarGraficoFavorito } = useContext(DashboardContext)
    const [isLoading, setIsLoading] = useState(false)

    const formatCurrency = (value) => {
        const formatter = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        return formatter.format(value);
    };

    const axisLabelRender = (args) => {
        theme == 'light' ? args.labelStyle.color = '#fff' : args.labelStyle.color = '#3f3f46'

        if (args.axis.name === 'primaryYAxis') {
            args.text = formatCurrency(Number(args.text));
        } else if (args.axis.name === 'primaryXAxis') {
            args.text = moment(args.text).format('L');
        }
    };

    const primaryxAxis = {
        title: '',
        titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' },
        labelIntersectAction: 'wrap',
        labelStyle: {
            textAlignment: 'center'
        },
        valueType: 'Category',
        interval: 1,
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 }
    };
    const primaryyAxis = { title: 'Custo', titleStyle: { color: theme == 'light' ? '#fff' : '#3f3f46' }, majorTickLines: { width: 0 }, majorGridLines: { width: 0 }, lineStyle: { width: 0 } }

    useEffect(() => {
        if (cicloDemandaKey != "") {
            setIsLoading(true)
            getCustoXTempo(cicloDemandaKey, qtdCustoXTempo)
                .then(() => {
                    setIsLoading(false)
                })
        }
    }, [cicloDemandaKey, qtdCustoXTempo])

    const onChartLoad = (args) => {
        document.getElementById('charts').setAttribute('title', '');
    };
    const load = (args) => {
    };

    const tooltipRender = (args) => {
        args.text = `${args.point.tooltip}: <b>${formatCurrency(Number(args.point.y))}</b>`;
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between', padding: '0' }}>
                <h2 className="h2-bsc">
                    <button onClick={() => AdicionarGraficoFavorito("Custo x Tempo")} className='btn-grafico'>{corFavorito("Custo x Tempo") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                    <span style={{ fontWeight: '500' }}>Custo x Tempo</span>
                </h2>
                <FormControl size="small" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="qtd-demanda-4">Quantidade de demandas</InputLabel>
                    <Select
                        className='span-bsc'
                        labelId="qtd-demanda-label-4"
                        id="qtd-demanda-4"
                        value={qtdCustoXTempo}
                        label="Quantidade de demandas"
                        onChange={(e) => setQtdCustoXTempo(parseInt(e.target.value))}
                    >
                        <MenuItem value="5">5</MenuItem>
                        <MenuItem value="10">10</MenuItem>
                        <MenuItem value="15">15</MenuItem>
                        <MenuItem value="20">20</MenuItem>
                        <MenuItem value="30">30</MenuItem>
                        <MenuItem value="40">40</MenuItem>
                        <MenuItem value="1000">Todas</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div style={{ width: '100%', minHeight: '450px' }}>
                {isLoading ?
                    <Skeleton variant="rounded" width="100%" height={450} />
                    :
                    <ChartComponent id='charts'
                        style={{ textAlign: "center" }}
                        primaryXAxis={primaryxAxis}
                        primaryYAxis={primaryyAxis}
                        axisLabelRender={axisLabelRender}
                        load={load.bind(this)}
                        loaded={onChartLoad.bind(this)}
                        legendSettings={{ visible: true, enableHighlight: true }}
                        tooltipRender={tooltipRender}
                        tooltip={{ enable: true }}
                        width="1200"
                        chartArea={{ border: { width: 0 } }}
                    >
                        <Inject services={[ScatterSeries, Legend, Tooltip, Category, Highlight]} />
                        <SeriesCollectionDirective>
                            <SeriesDirective dataSource={CustoXTempo} width={2} xName='x' yName='y' tooltipMappingName="toolTipMappingName" type='Scatter' marker={{ visible: false, width: 10, height: 10, shape: 'Circle' }} />
                        </SeriesCollectionDirective>
                    </ChartComponent>
                }
            </div>
        </>
    )
}